const styles = (theme) => ({
  card: {
    minHeight: 64,
    background: theme.color.white,
    boxShadow: `0px 1px 2px #0000001A`,
    borderRadius: 10,
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(5),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  noShadow: {
    boxShadow: 'none',
    border: `1px solid ${theme.color.grey_21}`,
  },
  noBox: {
    margin: 0,
    padding: 0,
    border: 0,
    boxShadow: 'none',
  },
  header: {
    padding: 0,
  },
  action: {
    margin: 0,
  },
  btn: {
    fontSize: 14,
    letterSpacing: 1.25,
    lineHeight: 1.43,
    color: theme.color.green_7c,
    textTransform: 'uppercase',
    minWidth: 0,
    padding: 0,
    border: 0,
    borderBottom: `2px solid ${theme.color.green_7c}`,
    background: 'none',
    cursor: 'pointer',
    transition: 'color 0.3s, opacity 0.3s',

    '&:hover, &:focus': {
      color: theme.color.green_7c,
      opacity: 0.8,
      background: 'none',
    },
  },
  content: {
    padding: 0,

    '&:last-child': {
      padding: 0,
    },
  },
});

export default styles;
